import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import axiosInstance from './services/axiosInstance';
import APIUrls from './services/APIUrls';

const AuthSuccess = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const isExecuted = useRef(false); // Track execution

    useEffect(() => {
        if (isExecuted.current) return; // Skip if already executed
        isExecuted.current = true; // Mark as executed

        const secureCode = new URLSearchParams(location.search).get('code');
        
        const fetchTokens = async () => {        
            try {                
                const response = await axiosInstance.get(APIUrls.GET_AUTH_TOKEN(secureCode));
                sessionStorage.setItem('access_token', response.data.access_token);
                sessionStorage.setItem('id_token', response.data.id_token);                      
                if(sessionStorage.getItem("cached_url")){
                    navigate(sessionStorage.getItem("cached_url"), { replace: true });    
                }else{
                    navigate('/dashboard', { replace: true });    
                }         
                
            } catch (error) {
                navigate('/', { 
                    replace: true,
                    state: { 
                        error: 'Authentication failed',
                        details: error.response?.data?.message 
                    }
                });
            }
        };

        if (secureCode) {
            fetchTokens();
        } else {
            navigate('/', { replace: true });
        }
    }, [navigate, location]);

    return <div>Completing authentication...</div>;
};

export default AuthSuccess;